import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Primitive, type PrimitiveProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';
import { buttonVariants, type ButtonVariants } from './index';

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant'];
  size?: ButtonVariants['size'];
  class?: HTMLAttributes['class'];
  type?: 'button' | 'submit' | 'reset';
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    variant: {},
    size: {},
    class: {},
    type: { default: 'button' },
    asChild: { type: Boolean },
    as: { default: 'button' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Primitive), {
    as: __props.as,
    "as-child": __props.asChild,
    type: __props.as === 'button' && !__props.asChild ? __props.type : undefined,
    class: _normalizeClass(_unref(cn)(_unref(buttonVariants)({ variant: __props.variant, size: __props.size }), props.class))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["as", "as-child", "type", "class"]))
}
}

})